import { Platform } from 'react-native';
import logger from 'redux-logger';
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';

import persistConfig from './persistConfig';
import rootReducer from '../reducers/rootReducer';
import { configureStore } from '@reduxjs/toolkit';
import { ENV_NAME, env } from '../constants/env';
import { __WEB__ } from '../constants/styles';

const getMiddlewares = () => {
  // this was not working correctly using import with webpack.
  const clientMiddleware = require('./middleware/clientMiddleware').default;

  const middleware = [clientMiddleware];
  if (__DEV__) {
    const reduxImmutableStateInvariant = require('redux-immutable-state-invariant').default();
    middleware.push(reduxImmutableStateInvariant);
    middleware.push(logger);
  }

  return middleware;
};

export default function configStore() {
  const reducer = !__WEB__ ? persistReducer(persistConfig, rootReducer) : rootReducer;

  const store = configureStore({
    reducer,
    devTools: env(ENV_NAME) !== 'production',
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
        immutableCheck: {
          warnAfter: 120,
        },
      }).concat(getMiddlewares()),
  });

  return { store };
}
